import React, { useRef, useState } from 'react';
import css from './TemplateModulesModal.module.scss';
import { classNames } from '../../../../../shared/libs/classNames';
import { TemplateModulesModalTabs } from '../tabs/TemplateModulesModalTabs';
import { SettingsButton } from '../../../../../shared/ui';
import { PrivateTemplateGalleryModulesTub } from '../gallery-modules/PrivateTemplateGalleryModulesTub';
import { useAppDispatch, useAppSelector } from '../../../../../shared/libs/redux';
import { NewModal } from '../../../../../components/ui/modals/new-modal';
import { templateModuleActions, templateModuleSelectors } from '../../../../../entities/template-module';
import { ModuleTagBindModal } from '../../../../module-tag-bind';
import { TemplateModuleCategoriesBar } from '../categories/bar/TemplateModuleCategoriesBar';
import { getAccount } from '../../../../../entities/user/account/personalAccountReducer';
import { accountSettingsAPI } from '../../../../../entities/user/account-settings/api/settingsApi';
import { TemplateModulesModalTabsEnum } from '../../model/types';
import { PrivateTemplateModulesTab } from '../entity-modules/PrivateTemplateModulesTab';
import { useModalStates } from './hooks/useModalStates';

interface ITemplateModulesModalProps {
	className?: string,
}

/**
 * Модальное окно модулей приватных шаблонов.
 */
export const PrivateTemplateModulesModal = ({ className }: ITemplateModulesModalProps) => {
	const dispatch = useAppDispatch();
	const [update] = accountSettingsAPI.useUpdateMutation();
	const scrollRef = useRef<HTMLDivElement>(null);

	// Настройка открытой по дефолту вкладки
	const account = useAppSelector(getAccount);
	const defaultTab = account.modalTab;

	const [currentTab, setCurrentTab] = useState(
		defaultTab,
	);

	const onOpenEditModuleWindow = () => {
		dispatch(templateModuleActions.setIsEditTemplateModuleActive(true));
	};

	const editor = useAppSelector(templateModuleSelectors.getEditor);

	const handleTemplateModal = (value: boolean) => {
		dispatch(templateModuleActions.setIsTemplateModuleActive({ editor, active: value }));
		if (!value) {
			dispatch(templateModuleActions.setSelectedCategoryIds([]));
		}
	};

	// Функция для изменения состояния чекбокса
	const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		// Определить выбран ли чекбокс
		const isChecked = event.target.checked;

		try {
			if ((currentTab === TemplateModulesModalTabsEnum.MODULES && isChecked)
				|| (currentTab === TemplateModulesModalTabsEnum.GALLERY && !isChecked)
			) {
				const updateData = {
					email: account.email,
					modal_module_tab_default: TemplateModulesModalTabsEnum.MODULES,
				};
				update(updateData).unwrap();
			} else if ((currentTab === TemplateModulesModalTabsEnum.GALLERY && isChecked)
				|| (currentTab === TemplateModulesModalTabsEnum.MODULES && !isChecked)) {
				const updateData = {
					email: account.email,
					modal_module_tab_default: TemplateModulesModalTabsEnum.GALLERY,
				};
				update(updateData).unwrap();
			}
		} catch (err) {
			// Логирование ошибки или уведомление пользователя
			console.error('Ошибка обновления аккаунта:', err);
		}
	};

	const {
		isActive,
		isEditModalActive,
		isDeleteGroupModalActive,
		isCreateGroupModalActive,
		isTagsSettingsModalActive,
		isEditModuleTagModalActive,
		isBindingTemplateModuleActive,
		isBindingWorkshopModuleActive,
		isDeleteWorkshopGroupModalActive,
		isEditWorkshopModuleTagModalActive,
		isCreateWorkshopModuleGroupModalActive,
		isCreateTemplateModuleGroupModalActive,
		isTemplateModuleTagsSettingsModalActive,
		isWorkshopModuleTagsSettingsModalActive,
		isCreatePrivateTemplateModuleGroupModalActive,
	} = useModalStates();

	return (
		<>
			<NewModal
				active={isActive}
				closeFunc={(value) => handleTemplateModal(value)}
				modalInModalActive={
					isEditModalActive
					|| isBindingTemplateModuleActive
					|| isBindingWorkshopModuleActive
					|| isCreateGroupModalActive
					|| isTagsSettingsModalActive
					|| isDeleteGroupModalActive
					|| isDeleteWorkshopGroupModalActive
					|| isEditWorkshopModuleTagModalActive
					|| isEditModuleTagModalActive
					|| isCreateWorkshopModuleGroupModalActive
					|| isCreateTemplateModuleGroupModalActive
					|| isTemplateModuleTagsSettingsModalActive
					|| isWorkshopModuleTagsSettingsModalActive
					|| isCreatePrivateTemplateModuleGroupModalActive
				}
			>
				<div className={classNames(css.wrapper, {}, [className])}>
					<div className={css.left_side} ref={scrollRef}>
						<div className={css.sticky_tabs}>
							<TemplateModulesModalTabs currentTab={currentTab} setCurrentTab={setCurrentTab} />
							<label htmlFor="checkbox">
								<input
									type="checkbox"
									id="checkbox"
									checked={currentTab === defaultTab}
									onChange={handleCheckboxChange}
								/>
								Открывать по умолчанию
							</label>
						</div>

						{/* Виджет с группами тегов */}
						{currentTab === TemplateModulesModalTabsEnum.MODULES
							? <PrivateTemplateModulesTab scrollRef={scrollRef} />
							: <PrivateTemplateGalleryModulesTub scrollRef={scrollRef} />}

					</div>

					{/* Блок с категориями */}
					<div className={css.right_side}>
						<div className={css.categories}>
							<TemplateModuleCategoriesBar />
						</div>
						{
							currentTab === TemplateModulesModalTabsEnum.MODULES && (
								<SettingsButton onClick={onOpenEditModuleWindow} />
							)
						}
					</div>
				</div>
			</NewModal>
			<ModuleTagBindModal />
		</>
	);
};
